module.exports = "/_next/static/images/abcc45c9cb8b2cb1ad0fe6eb7ac25052-hero-lg.jpg";